import { render, staticRenderFns } from "./identifier.vue?vue&type=template&id=51c0b4ae"
import script from "./identifier.vue?vue&type=script&lang=js"
export * from "./identifier.vue?vue&type=script&lang=js"
import style0 from "./identifier.vue?vue&type=style&index=0&id=51c0b4ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports